import { render } from "./CustomerOrderView.vue?vue&type=template&id=e2d82b8a"
import script from "./CustomerOrderView.vue?vue&type=script&lang=js"
export * from "./CustomerOrderView.vue?vue&type=script&lang=js"

import "./CustomerOrderView.vue?vue&type=style&index=0&id=e2d82b8a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__